import React from 'react';
import { TypographyProps, TypographyVariant, TypographyElement } from '../../../types/DesignSystem/Typography';

const variantToClass: Record<TypographyVariant, string> = {
  display: 'tw-text-display',
  'heading-1': 'tw-text-heading-1',
  'heading-2': 'tw-text-heading-2',
  'title-header': 'tw-text-title-header',
  title: 'tw-text-title',
  'body-primary': 'tw-text-body-primary',
  'sub-title-header': 'tw-text-sub-title-header',
  'sub-title-label': 'tw-text-sub-title-label',
  'sub-body-supporting': 'tw-text-sub-body-supporting',
  'caption-metadata': 'tw-text-caption-metadata',
  'code-formula': 'tw-text-code-formula',
};

const defaultElements: Record<TypographyVariant, TypographyElement> = {
  display: 'h1',
  'heading-1': 'h2',
  'heading-2': 'h3',
  'title-header': 'h4',
  title: 'h5',
  'body-primary': 'p',
  'sub-title-header': 'h6',
  'sub-title-label': 'span',
  'sub-body-supporting': 'span',
  'caption-metadata': 'span',
  'code-formula': 'code',
};

const Typography: React.FC<TypographyProps> = ({
  variant,
  as,
  children,
  className = '',
}) => {
  const Component = as || defaultElements[variant];
  const textClass = variantToClass[variant];

  return React.createElement(
    Component,
    {
      className: `${textClass} ${className}`,
    },
    children
  );
};

export default Typography;
